// extracted by mini-css-extract-plugin
export default {"page__container":"RecognitionForm_page__container__6GZyz"};